import { jsx, jsxs } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';

function HeaderFlow({ children = null, className = '', }) {
    return (jsx("div", { className: cns('application__header', 'application__header--flow', className), children: children }));
}
function Header({ children = null, className = '', logo = null, appName = null, flow = false, }) {
    if (flow) {
        return jsx(HeaderFlow, { className: className, children: children });
    }
    return (jsxs("div", { className: cns('application__header', className), children: [jsx("div", { className: "application__logo", children: logo || 'Servizi CGN' }), children, appName && (jsx("div", { className: "application__header-name", children: appName }))] }));
}
Header.displayName = 'Application.Header';

export { Header as default };
